
function getRoutes() {

  switch (location.hostname) {
    case '127.0.0.1':
    case 'client6.docs.munixo.com': {
      return [
        {
          path: '/',
          meta: { mandantId: 'novicon', docuId: 'novicon-7106' },
          component: () => import('layouts/MainLayout.vue'),
          children: [
            { name: 'Home', path: '/', component: () => import('pages/HomePage.vue') },
            { name: 'Page', path: '/:pageId+', component: () => import('pages/IndexPage.vue') },
            { name: 'Search', path: '/-/search/:term', component: () => import('pages/SearchPage.vue') },
            {
              name: 'NotFound',
              path: '/:catchAll(.*)*',
              component: () => import('pages/ErrorNotFound.vue')
            }
          ]
        },
        // Always leave this as last one,
        // but you can also remove it
        { name: 'Settings', path: '/-/settings', component: () => import('pages/SettingsPage.vue') },
        {
          name: 'NotFound',
          path: '/:catchAll(.*)*',
          component: () => import('pages/ErrorNotFound.vue')
        }
      ]
    }
    default: {
      return [
        {
          path: '/',
          component: () => import('layouts/MainLayout.vue'),
          children: [
            { name: 'Home', path: '/:mandantId/:docuId', component: () => import('pages/HomePage.vue') },
            { name: 'Page', path: '/:mandantId/:docuId/:pageId+', component: () => import('pages/IndexPage.vue') },
            { name: 'Search', path: '/:mandantId/:docuId/-/search/:term', component: () => import('pages/SearchPage.vue') },

          ]
        },
        // Always leave this as last one,
        // but you can also remove it
        { name: 'Settings', path: '/:mandantId/:docuId/-/settings', component: () => import('pages/SettingsPage.vue') },
        {
          name: 'NotFound',
          path: '/:catchAll(.*)*',
          component: () => import('pages/ErrorNotFound.vue')
        }
      ]
    }
  }
}

const routes = getRoutes();

export default routes
